import axiosOverlay from "../../js/axiosOverlay"

const state = {
    collaborateurs: null
};

const getters = {
    collaborateurs: state => state.collaborateurs,
    getCollaborateurByID: (state) => (CollaborateurID) => {
        if (!state.collaborateurs) return null;
        let result = JSON.parse(state.collaborateurs).filter(collaborateur => collaborateur.id === CollaborateurID)[0]
        return result
    }
};

const mutations = {
    SET_COLLABORATEURS(state, collaborateurs) {
        state.collaborateurs = collaborateurs;
    }
};

const actions = {
    async loadCollaborateurs({ commit, state }) {
        if (!state.collaborateurs) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + '/collaborateurs?pagination=false',
                headers: {}
            };

            try {
                const response = await axiosOverlay(config);
                commit('SET_COLLABORATEURS', JSON.stringify(response.data));
            } catch (error) {
                console.log(error);
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
